export default "__VITE_ASSET__CsD3akMx__";